<template>
  <section>
    <v-flex xs12 md12 pt-2 pl-2 pr-2>
      <v-card>
        <v-card-title primary-title class="headline primary">
          <v-layout row align-center>
            <v-btn dark icon @click="$router.push('/settings/loyalty_tiers')">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <span class="title font-weight-light white--text"
              >Edit Loyalty Tier</span
            >
          </v-layout>
        </v-card-title>
        <v-flex pt-1>
          <v-card-text key="1">
            <LoyaltyTierForm
              v-if="loyaltyTier != null"
              ref="loyaltyTierForm"
              :loyaltyTier="loyaltyTier"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
              @imageInput="handleImageInput"
            />
          </v-card-text>
        </v-flex>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="text-none" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="snackbarShow"
        :color="snackbarColour"
        :timeout="4000"
        >{{ snackbarMessage }}</v-snackbar
      >
    </v-flex>
  </section>
</template>

<script>
import LoyaltyTierForm from "@/components/settings/loyalty/LoyaltyTierForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "update_loyalty_tier",
  components: {
    LoyaltyTierForm,
  },
  props: {},
  data: function () {
    return {
      loyaltyTier: null,
      errors: {},
      loyaltyTierFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
    };
  },
  mounted: function () {
    console.log("Mounted");
    this.getLoyaltyTier();
  },
  methods: {
    getLoyaltyTier: async function () {
      console.log("loyalty tier");

      this.disabled = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/settings/loyalty_tiers/${this.$route.params.id}/get`;

      console.log("Getting loyalty tiers");

      axios
        .get(url)
        .then(function (response) {
          if (!response.error) {
            if (response.data.loyalty_tier) {
              self.disabled = false;
              self.loyaltyTier = response.data.loyalty_tier;
            }
          } else {
            console.log(response.error);
            self.showSnackbar(
              "Error fetching loyalty tier: " + response.error,
              "error"
            );
          }
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          self.showSnackbar(error, "error");
          self.loading = false;
        });
    },
    submit: async function () {
      if (this.loyaltyTierFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/loyalty_tiers/${this.loyaltyTier.id}/update`;

        var data = Object.assign({}, this.loyaltyTier);

        data.name = encodeURI(data.name);
        data.description = encodeURI(data.description);

        axios({
          url: url,
          method: "post",
          data: {
            loyalty_tier: data,
          },
          headers: {
            "Content-Type": "text/plain",
          },
        })
          .then(function (response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              if (self.errors.loyalty_tier) {
                self.errors = {
                  ...self.errors.loyalty_tier,
                };
              }
              self.showSnackbar(
                "Error updating loyalty tier, please check the form",
                "error"
              );
            } else if (response.data.error != "no_error") {
              self.showSnackbar(
                "Error updating loyalty tier: " + response.data.error,
                "error"
              );
              console.log(response.data.error);
            } else {
              self.$router.push("/settings/loyalty_tiers");
            }
          })
          .catch(function (error) {
            console.log(error);
            self.showSnackbar("Network error: " + error, "error");
          });
      } else {
        this.showSnackbar(
          "Please complete the form before submitting",
          "error"
        );
        this.$refs.loyaltyTierForm.validateForm();
      }
    },
    updateFormValidity: function (value) {
      this.loyaltyTierFormValid = value;
    },
    handleImageInput: function (file) {
      this.loyaltyTier.image = file;
    },
    showSnackbar: function (message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
  },
};
</script>